<div class="twitter-feeds">
  <span>
    <img alt="cbw-img" class="twitter-feeds--img" src="./assets/images/cbw-trust-knowledge-transparency.jpg" />
  </span>
  <div class="twitter-feeds--content">
    <span class="twitter-feeds--content--twitter-text">Twitter Feeds</span>
    <span class="orange-line"></span>
  </div>
</div>
